import React from 'react';

import CardHOC from './Components/CardHOC';
import Display from '../../Types/Components/Display';

export default function (props) {
  return <CardHOC question={props.question}>
    <Display {...props} />
  </CardHOC>;
}